import PATH from '../paths';

const name = 'Worldwide Capital Partners';
const key = 'worldwidecapitalpartners';
const imgUrl = `${ PATH.CDN }/whitelabels/wcp`;
const images = {
  favicon: `${ imgUrl }/favicon.ico`,
  logo: `${ imgUrl }/logo.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/bg.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-wcp-yellow:               #E1A400;

    --color-primary:                  var(--color-wcp-yellow);
    --color-secondary:                var(--color-darker);
    --color-accent:                   var(--color-white);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-blue);
    --color-link-hover:               rgb(var(--color-blue-dark));

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              var(--color-black);
    --anonymous-copy-bg:              var(--color-black);
    --anonymous-heading-color:        var(--color-wcp-yellow);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          50px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-dark);
    --sidebar-logo-bg-color: var(--color-black);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-dark);
    --sidebar-button-color-hover: var(--color-dark);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-wcp-yellow);
    --sidebar-button-bg-color-hover: var(--color-accent);
    --sidebar-button-border-color: var(--color-accent);
    --sidebar-button-border-color-active: var(--color-wcp-yellow);
    --sidebar-button-border-color-hover: var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-dark);
    --btn-primary--border:            var(--color-dark);
    --btn-primary--color:             var(--color-wcp-yellow);
    --btn-primary--colorH:            var(--color-dark);
    --btn-primary--bgH:               var(--color-wcp-yellow);
    --btn-primary--borderH:           var(--color-wcp-yellow);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-dark);
    --btn-secondary--color:           var(--color-wcp-yellow);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-dark);
    --btn-secondary--colorH:          var(--color-dark);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
